const descriptor = {
  columns: [//описание столбцов таблицы
      {
        title: 'message',
        value: 'message',
        dataKey: 'message',
        filter: true,
        type: 'text',
        width: '40%'
      },
      {
        title: 'status',
        value: 'status',
        dataKey: 'status',
        filter: true,
        type: 'text',
        width: '30%'
      },
      {
        title: 'processing',
        value: 'processing',
        dataKey: 'processing',
        filter: true,
        type: 'text',
        width: '30%'
      },
  ],
}

export default descriptor